import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "error-msg-wrap" }
const _hoisted_2 = {
  class: "form-wrapper slide-up",
  style: {"width":"480px"}
}
const _hoisted_3 = { class: "form-close" }
const _hoisted_4 = { class: "sb-modal-title" }
const _hoisted_5 = {
  key: 0,
  class: "sb-intro"
}
const _hoisted_6 = { class: "sb-intro" }
const _hoisted_7 = { class: "sb-nudge-l" }
const _hoisted_8 = {
  key: 0,
  class: "sb-nudge-ok"
}
const _hoisted_9 = {
  key: 1,
  class: "sb-nudge-warn"
}
const _hoisted_10 = {
  key: 0,
  class: "sb-nudge-msg"
}
const _hoisted_11 = {
  key: 1,
  class: "sb-nudge-msg"
}
const _hoisted_12 = { class: "sb-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "form-close-x",
          title: "Close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, "×")
      ]),
      _createElementVNode("h2", _hoisted_4, "Remind " + _toDisplayString(_ctx.teamLabel(_ctx.team)), 1),
      (!_ctx.loaded)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, "Loading…"))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.texted.length ? 'Each person gets a text listing the numbers they still need to enter this week.' : 'There\'s no one to text.'), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recipients, (r) => {
              return (_openBlock(), _createElementBlock("div", {
                key: r.EmployeeID,
                class: "sb-nudge-row"
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("b", null, _toDisplayString(r.Name), 1),
                  _createElementVNode("span", null, _toDisplayString(r.Metrics.join(', ')), 1)
                ]),
                (r.HasPhone)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Text"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_9, "No phone"))
              ]))
            }), 128)),
            (_ctx.noPhone.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createTextVNode(_toDisplayString(_ctx.listNames(_ctx.noPhone.map(r => r.Name))) + " " + _toDisplayString(_ctx.noPhone.length == 1 ? 'doesn\'t' : 'don\'t') + " have a phone number, so they won't get a text. Add one to their employee record", 1),
                  (_ctx.isAdmin)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _cache[3] || (_cache[3] = _createTextVNode(": ", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.noPhone, (r, i) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: r.EmployeeID
                          }, [
                            _createVNode(_component_router_link, {
                              to: '/employee/' + r.EmployeeID
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(r.Name), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"]),
                            _createTextVNode(_toDisplayString(i < _ctx.noPhone.length - 1 ? ', ' : ''), 1)
                          ], 64))
                        }), 128))
                      ], 64))
                    : _createCommentVNode("", true),
                  _cache[4] || (_cache[4] = _createTextVNode(". ", -1))
                ]))
              : _createCommentVNode("", true),
            (_ctx.unowned)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.unowned) + " metric" + _toDisplayString(_ctx.unowned == 1 ? ' has' : 's have') + " no owner, so no one gets reminded about " + _toDisplayString(_ctx.unowned == 1 ? 'it' : 'them') + ". ", 1))
              : _createCommentVNode("", true)
          ], 64)),
      _createElementVNode("div", _hoisted_12, [
        _cache[5] || (_cache[5] = _createElementVNode("span", { style: {"flex":"1"} }, null, -1)),
        _createElementVNode("div", {
          class: "btn-light",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
        }, "Cancel"),
        (_ctx.texted.length)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["btn", _ctx.sending ? 'disable-button' : '']),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.send()))
            }, "Send " + _toDisplayString(_ctx.texted.length) + " Text" + _toDisplayString(_ctx.texted.length == 1 ? '' : 's'), 3))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}